// extracted by mini-css-extract-plugin
module.exports = {"switch":"switch_switch__1f1aO","icon--off":"switch_icon--off__2094T","icon--on":"switch_icon--on__b4V0Q"};